/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Taskpage_Subtitle_DailytaskInputs */

const en_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Challenges`)
};

const ar_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديات اليومية`)
};

const de_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Herausforderungen`)
};

const es_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafíos diarios`)
};

const fr_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défis Quotidiens`)
};

const it_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfide Giornaliere`)
};

const ja_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーチャレンジ`)
};

const ko_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 챌린지`)
};

const pt_br_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafios diários`)
};

const ru_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневные задания`)
};

const th_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความท้าทายประจำวัน`)
};

const tr_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Mücadeleler`)
};

const zh_cn_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日挑战`)
};

const zh_tw_taskpage_subtitle_dailytask = /** @type {(inputs: Taskpage_Subtitle_DailytaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日挑戰`)
};

/**
* | output |
* | --- |
* | "Daily Challenges" |
*
* @param {Taskpage_Subtitle_DailytaskInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const taskpage_subtitle_dailytask = /** @type {((inputs?: Taskpage_Subtitle_DailytaskInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Taskpage_Subtitle_DailytaskInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_taskpage_subtitle_dailytask(inputs)
	if (locale === "ar") return ar_taskpage_subtitle_dailytask(inputs)
	if (locale === "de") return de_taskpage_subtitle_dailytask(inputs)
	if (locale === "es") return es_taskpage_subtitle_dailytask(inputs)
	if (locale === "fr") return fr_taskpage_subtitle_dailytask(inputs)
	if (locale === "it") return it_taskpage_subtitle_dailytask(inputs)
	if (locale === "ja") return ja_taskpage_subtitle_dailytask(inputs)
	if (locale === "ko") return ko_taskpage_subtitle_dailytask(inputs)
	if (locale === "pt_br") return pt_br_taskpage_subtitle_dailytask(inputs)
	if (locale === "ru") return ru_taskpage_subtitle_dailytask(inputs)
	if (locale === "th") return th_taskpage_subtitle_dailytask(inputs)
	if (locale === "tr") return tr_taskpage_subtitle_dailytask(inputs)
	if (locale === "zh_cn") return zh_cn_taskpage_subtitle_dailytask(inputs)
	return zh_tw_taskpage_subtitle_dailytask(inputs)
});